module.exports = __webpack_public_path__ + "static/media/business-not-enrolled.9ada3f22.svg";